import React, { useState, useEffect } from 'react';
import './DeleteConfirmationModal.css';

export default function DeleteConfirmationModal({ isOpen, onClose, onConfirm, offeringTitle }) {
  const [isDeleting, setIsDeleting] = useState(false);

  // Reset loading state when the modal opens/closes
  useEffect(() => {
    if (!isOpen) {
      setIsDeleting(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleConfirmClick = async () => {
    setIsDeleting(true);
    try {
      await onConfirm();
    } catch (err) {
      setIsDeleting(false);
    }
  };

  const handleCloseClick = () => {
    if (isDeleting) return;
    onClose();
  };

  return (
    <div className="off-modal-overlay">
      <div className="off-modal-content">
        <h2 className="off-modal-title">Delete this offering?</h2>
        <p className="off-modal-body">
          This will permanently remove <strong>{offeringTitle || "this offering"}</strong>. Any existing bookings will not be affected.
        </p>
        <div className="off-modal-actions">
          <button 
            className="off-modal-btn off-modal-btn--ghost" 
            onClick={handleCloseClick}
            disabled={isDeleting}
          >
            Cancel
          </button>
          <button 
            className="off-modal-btn off-modal-btn--danger" 
            onClick={handleConfirmClick}
            disabled={isDeleting}
            style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}
          >
            {isDeleting ? (
              <>
                <span className="off-modal-spinner"></span>
                Deleting...
              </>
            ) : (
              "Yes, Delete It"
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
